'use client'

import { useMedia } from '@/hooks'
import LayoutFragment from '@/lib/fragments/layout'
import { Lib } from '@/types'
import { MEDIA } from '@config'
import dynamic from 'next/dynamic'
import { memo } from 'react'
import HeaderContainer from './components/HeaderContainer'
import Nav from './components/Nav'

const NavMobile = dynamic(() => import('./components/NavMobile'), {
  ssr: false
})

export interface HeaderProps {
  data: Lib.FragmentOf<typeof LayoutFragment> | null
}

const Header = ({ data }: HeaderProps) => {
  const desktop = useMedia(MEDIA.lg)

  if (!data) return null
  return (
    <>
      <HeaderContainer>
        <Nav data={data} />
      </HeaderContainer>
      {!desktop && <NavMobile data={data} />}
    </>
  )
}

export default memo(Header)
